module.exports = __webpack_public_path__ + "img/South_Ayrshire.a9b61628.png";